$(document).ready(function () {
  $("a[href^='#'].Anker").click(function () {
    var t; return t = $($(this).attr("href")), 0 != t.length ? ($("html, body").animate({
      scrollTop: t.offset().top - $("#Header").outerHeight()
    }, 2500), !1) : void 0
  })
});
